
/**
 * Contains context extraction helpers and related types
 */
export interface ConversationContext {
  participants?: {
    name: string;
    known: boolean;
    details?: string;
  }[];
  location?: {
    name: string;
    address?: string;
    needsConfirmation: boolean;
  };
  time?: {
    proposed: string;
    confirmed: boolean;
  };
}

// Helper functions for context extraction
export function extractParticipants(content: string): ConversationContext['participants'] {
  const matches = content.match(/with ([^.!?,]+)/i);
  if (!matches) return [];
  const names = matches[1].split(' and ').map(name => name.trim());
  return names.map(name => ({
    name,
    known: false, // We'll need to check against our database
  }));
}

export function extractLocation(content: string): ConversationContext['location'] {
  const matches = content.match(/at ([^.!?,]+)/i);
  if (!matches) return undefined;
  return {
    name: matches[1].trim(),
    needsConfirmation: true
  };
}

export function extractTimeInfo(content: string): ConversationContext['time'] {
  const timeMatch = content.match(/\d{1,2}(?::\d{2})?\s*(?:am|pm|a|p)?/i);
  if (!timeMatch) return undefined;
  return {
    proposed: timeMatch[0],
    confirmed: false
  };
}
